import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";

export function isOwnedTemporaryPhoto(candidate: URL, roots: URL[]): boolean {
  return candidate.protocol === "file:" && /\.jpe?g$/i.test(candidate.pathname)
    && !/%(?:2e|2f|5c|00)/i.test(candidate.pathname)
    && roots.some((root) => root.protocol === "file:" && root.host === candidate.host
      && candidate.pathname.startsWith(`${root.pathname.replace(/\/$/, "")}/`));
}

export async function removeNativePhotoCopy(path: string | undefined): Promise<void> {
  if (!path) return;
  const candidate = new URL(path);
  const cache = await Filesystem.getUri({ directory: Directory.Cache, path: "" });
  const roots = [new URL(cache.uri)];
  if (Capacitor.getPlatform() === "android") {
    const pictures = await Filesystem.getUri({ directory: Directory.External, path: "Pictures" });
    roots.push(new URL(pictures.uri));
  } else if (Capacitor.getPlatform() === "ios") {
    const library = await Filesystem.getUri({ directory: Directory.Library, path: "" });
    roots.push(new URL("../tmp/", `${library.uri.replace(/\/$/, "")}/`));
  }
  // Delete only a JPEG copy inside this app's temporary camera directories.
  // Never delete a user's library file, content URI, or another app's data.
  if (isOwnedTemporaryPhoto(candidate, roots)) await Filesystem.deleteFile({ path: candidate.href });
}
